import * as tslib_1 from "tslib";
import { noop } from './utils';
export var SPEC_ENDPOINTS = {
    internalMonitoringEndpoint: 'https://monitoring-intake.com/abcde?foo=bar',
    logsEndpoint: 'https://logs-intake.com/abcde?foo=bar',
    rumEndpoint: 'https://rum-intake.com/abcde?foo=bar',
    traceEndpoint: 'https://trace-intake.com/abcde?foo=bar',
};
export function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
export function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}
export function isIE() {
    return navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}
export function clearAllCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c.replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
var FetchStubBuilder = /** @class */ (function () {
    function FetchStubBuilder(observable) {
        var _this = this;
        this.requests = [];
        this.pendingFetch = 0;
        this.whenAllCompleteFn = noop;
        observable.subscribe(function (request) {
            _this.requests.push(request);
            _this.pendingFetch -= 1;
            if (_this.pendingFetch === 0) {
                // ensure that AssertionError are not swallowed by promise context
                setTimeout(function () {
                    _this.whenAllCompleteFn(_this.requests);
                });
            }
        });
    }
    FetchStubBuilder.prototype.whenAllComplete = function (onCompleteFn) {
        this.whenAllCompleteFn = onCompleteFn;
    };
    FetchStubBuilder.prototype.getStub = function () {
        var _this = this;
        return (function () {
            _this.pendingFetch += 1;
            var resolve;
            var reject;
            var promise = new Promise(function (res, rej) {
                resolve = res;
                reject = rej;
            });
            promise.resolveWith = function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, resolve(tslib_1.__assign({}, response, { clone: function () {
                                var cloned = {
                                    text: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                        return tslib_1.__generator(this, function (_a) {
                                            if (response.responseTextError) {
                                                throw response.responseTextError;
                                            }
                                            return [2 /*return*/, response.responseText];
                                        });
                                    }); },
                                };
                                return cloned;
                            } }))];
                });
            }); };
            promise.rejectWith = function (error) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, reject(error)];
            }); }); };
            return promise;
        });
    };
    return FetchStubBuilder;
}());
export { FetchStubBuilder };
var PerformanceObserverStubBuilder = /** @class */ (function () {
    function PerformanceObserverStubBuilder() {
    }
    PerformanceObserverStubBuilder.prototype.fakeEntry = function (entry, entryType) {
        var asEntryList = function () { return [entry]; };
        // tslint:disable-next-line: no-unsafe-any
        this.instance.callback({
            getEntries: asEntryList,
            getEntriesByName: asEntryList,
            getEntriesByType: function (type) {
                if (type === entryType) {
                    return asEntryList();
                }
                return [];
            },
        });
    };
    PerformanceObserverStubBuilder.prototype.getStub = function () {
        var _a;
        // tslint:disable-next-line:no-this-assignment
        var builder = this;
        return _a = /** @class */ (function () {
                function class_1(callback) {
                    this.callback = callback;
                    builder.instance = this;
                }
                class_1.prototype.observe = function (options) {
                    // do nothing
                };
                return class_1;
            }()),
            _a.supportedEntryTypes = ['navigation'],
            _a;
    };
    return PerformanceObserverStubBuilder;
}());
export { PerformanceObserverStubBuilder };
//# sourceMappingURL=specHelper.js.map